import Button from 'components/form-elements/Button';
import ButtonCol from 'components/form-elements/ButtonCol';
import InputCol from 'components/form-elements/InputCol';
import Col from 'components/ui-elements/Col';
import { LangLabel } from 'data/LangLabel';
import useAxiosFunction from 'hooks/useAxiosFunction';
import React, { Fragment, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Card from 'components/ui-elements/Card';
import Row from 'components/ui-elements/Row';
import DropdownCol from 'components/form-elements/DropdownCol';
import DatepickerCol from 'components/form-elements/DatepickerCol';
import CheckboxCol from 'components/form-elements/CheckboxCol';
import CheckboxFormCol from 'components/form-elements/CheckboxFormCol';
import useMsgBox from 'hooks/useMsgBox';
import ItemInput from './ItemInput';


const MyForm = (props) => {
    const {
        url,
        onSuccess,
        onError,
        onChangeForm,
        onCancel,
        coltype,
        columns,
        title,
        defaultValue,
        children,
        lblsave = LangLabel.LABEL_SAVE,
        lblcancel = LangLabel.LABEL_CANCEL,
        confirmSubmitTitle = "Konfirmasi",
        confirmSubmitMessage = "",
        saveHandle = null,
        saveDisabled = false,
        saveColsize = 2,
        cancelColsize = 2,
        ...rest
    } = props

    const [showMsg, confirmMsg] = useMsgBox();
    const [resp, error, loading, axiosFetch] = useAxiosFunction();
    const { setValue, register, handleSubmit, watch, control, formState: { errors } } = useForm();
    const alldata = watch()
    const appliedDefaultRef = useRef(null)

    useEffect(() => {
        if (!defaultValue) return
        const defaultKey = JSON.stringify(defaultValue)
        if (appliedDefaultRef.current === defaultKey) return
        appliedDefaultRef.current = defaultKey
        if (Object.keys(defaultValue).length > 0) {
            const keys = Object.keys(defaultValue)
            keys.forEach((key) => {
                setValue(key, defaultValue[key])
            })
        }
    }, [defaultValue, setValue])

    useEffect(() => {
        onChangeForm(setValue, alldata)
    }, [JSON.stringify(alldata)])

    const onSubmit = async (reqdata) => {
        if (confirmSubmitMessage) {
            const ok = await confirmMsg(confirmSubmitTitle, confirmSubmitMessage)
            if (!ok) return
        }
        let hasil = null
        if (typeof saveHandle === 'function') {
            hasil = await saveHandle(reqdata, defaultValue)
        } else {
            hasil = await axiosFetch({
                method: 'POST',
                url: url,
                data: reqdata,
                auth: true
            })
        }

        if (hasil?.data?.success === true) {
            await showMsg("Informasi", "Data berhasil disimpan.")
            onSuccess()
        } else if (hasil?.data?.success === false) {
            await showMsg("Error", hasil?.message)
            onError(hasil?.message)
        } else {
            await showMsg("Error", "Tidak terhubung ke server!")
            onError("Tidak terhubung ke server!")
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Card title={title}>
                    <Row>
                        {columns && columns.map((elname, idx) => {
                            const element = coltype?.[elname]
                            return <ItemInput
                                elname={elname}
                                {...element}
                                setValue={setValue}
                                register={register}
                                handleSubmit={handleSubmit}
                                watch={watch}
                                errors={errors}
                                control={control}
                                key={"input-item" + idx}
                                idx={idx}
                                defaultValue={defaultValue}
                                coltype={coltype}
                            />

                            /*let { type, value, label, name, validation, options, colsize, ...rest } = element
                            name = name ? name : elname
                            const colsz = colsize ? colsize : "3"
                            let ret = ""
                            switch (element?.type) {
                                case "hidden":
                                    ret = <input key={"formel-" + idx} type={type} {...rest} {...register(name, { value: { value } })} />
                                    break;
                                case "text":
                                    ret = <InputCol key={"formel-" + idx} colsize={colsz} {...rest} name={name} error={errors?.[name + ""]?.message} register={register} validation={validation} label={label} />
                                    break;
                                case "password":
                                    ret = <InputCol type="password" key={"formel-" + idx} colsize={colsz} {...rest} name={name} error={errors?.[name + ""]?.message} register={register} validation={validation} label={label} />
                                    break;
                                case "dropdown":
                                    ret = options && <DropdownCol
                                        colsize={colsz}
                                        name={name}
                                        error={errors?.[name]?.message}
                                        register={register}
                                        validation={validation}
                                        label={label}
                                        options={options}
                                        {...rest}
                                        key={"formel-" + idx}
                                    />
                                    break;
                                case "date":
                                    ret = <DatepickerCol key={"formel-" + idx} {...rest} colsize={colsz} name={name} error={errors?.[name]?.message} register={register} setValue={setValue} validation={validation} label={label} />
                                    break;
                                case "checkbox":
                                    ret = <CheckboxCol key={"formel-" + idx} {...rest} colsize={colsz} name={name} error={errors?.[name]?.message} register={register} label={label} />
                                    break;
                                case "checkboxform":
                                    ret = <CheckboxFormCol key={"formel-" + idx} {...rest} colsize={colsz} name={name} error={errors?.[name]?.message} register={register} label={label} />
                                    break;
                                case "divider":
                                    ret = <div style={{ borderTop: "1px solid #CCCCCC", clear: "left", display: "block", width: "100%", marginLeft: "8px", marginRight: "8px" }}>&nbsp;</div>
                                    break;
                                default:
                                    break;
                            }
                            return element && ret*/
                        })}
                    </Row>
                </Card>

                {children &&
                    <Card className="mb-3 mt-0">
                        <Row>
                            {children}
                        </Row>
                    </Card>
                }

                {columns && coltype &&
                    <Card className="mb-0">
                        <Row>
                            <ButtonCol colsize={saveColsize} loading={loading} disabled={saveDisabled} type="submit" title={lblsave} block={true} />
                            <Col size={cancelColsize}>
                                <Button onClick={() => onCancel()} title={lblcancel} block={true} />
                            </Col>
                        </Row>
                    </Card>
                }
            </form>
        </>
    )
}

MyForm.defaultProps = {
    onSuccess: () => { },
    onError: () => { },
    onCancel: () => { },
    onChangeForm: (setVal, data) => { },
    defaultValue: {},
    saveHandle: null,
    saveColsize: 2,
    cancelColsize: 2,
}

export default MyForm
